export const STEPS = {
  SIGNUP_CLEANER: 1,
  PERSONAL_INFO: 2,
  BACKGROUND_CHECK: 3,
  COMPLETED: 4,
};

/** When false, signup skips email OTP; keep in sync with OTP UI in sign-up-cleaner-form. */
export const SIGNUP_EMAIL_OTP_ENABLED = false;

export enum VISUAL {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
}
